import axios, { AxiosPromise } from "axios";
import {
  BulkInviteDto,
  BulkInviteResultDto,
  BulkInviteResourceApi,
} from "../generated/dashboard-client";
import { env } from "../env/env";
import { dashboardApiConfig, ops } from "./config";

const api = new BulkInviteResourceApi(dashboardApiConfig);

// An email that can't be invited because an account already exists (returned by the review-time check).
export interface BulkInviteEmailIssue {
  email: string;
  reason: string;
}

const BulkInviteApi = {
  bulkInvite(teamId: string, dto: BulkInviteDto): AxiosPromise<BulkInviteResultDto> {
    return api.bulkInvite(teamId, dto, ops());
  },

  // Direct axios call — regenerate the client (`npm run gen dashboard`) to move this onto
  // BulkInviteResourceApi once the backend endpoint is live.
  validateEmails(teamId: string, emails: string[]): AxiosPromise<BulkInviteEmailIssue[]> {
    return axios.post(`${env.apiPath}/teams/${teamId}/bulk-invite/validate`, { emails }, ops());
  },
};

export default BulkInviteApi;
